<a [routerLink]="route" routerLinkActive="active" class="menu-link" (click)="onItemClick()">
    {{ label | translate }}
</a>
